import React, { useState } from "react"
import { useNavigate } from "react-router-dom"

interface Props {
  displaySize: string;
}

export default function Carousel({displaySize}:Props) {
  const [activeIndex, setActiveIndex] = useState(0)
  const [selectedSport, setSelectedSport] = useState(null)
  const navigate = useNavigate()

  const largeViewSportOptions = [
    [
      { name: "Tennis", image: require("../../../assets/landingAssets/carouselAssets/tennis.png") },
      { name: "Golf", image: require("../../../assets/landingAssets/carouselAssets/golf.png") },
      { name: "Pickleball", image: require("../../../assets/landingAssets/carouselAssets/pickleball.png") },
      { name: "Football", image: require("../../../assets/landingAssets/carouselAssets/football.png") },
      { name: "Soccer", image: require("../../../assets/landingAssets/carouselAssets/soccer.png") }
    ],
    [
      { name: "Baseball", image: require("../../../assets/landingAssets/carouselAssets/baseball.png") },
      { name: "Basketball", image: require("../../../assets/landingAssets/carouselAssets/basketball.png") },
      { name: "Running", image: require("../../../assets/landingAssets/carouselAssets/running.png") },
      { name: "Softball", image: require("../../../assets/landingAssets/carouselAssets/softball.png") },
      { name: "Swimming", image: require("../../../assets/landingAssets/carouselAssets/swimming.png") }
    ],
    [
      { name: "Cycling", image: require("../../../assets/landingAssets/carouselAssets/cycling.png") },
      { name: "Volleyball", image: require("../../../assets/landingAssets/carouselAssets/volleyball.png") },
      { name: "Martial Arts", image: require("../../../assets/landingAssets/carouselAssets/wrestling.png") },
      { name: "Water Polo", image: require("../../../assets/landingAssets/carouselAssets/water-polo.png") },
      { name: "Skiing", image: require("../../../assets/landingAssets/carouselAssets/skiing.png") }
    ],
    [
      { name: "Track & Field", image: require("../../../assets/landingAssets/carouselAssets/track-and-field.png") },
      { name: "Rugby", image: require("../../../assets/landingAssets/carouselAssets/rugby.png") },
      { name: "Field Hockey", image: require("../../../assets/landingAssets/carouselAssets/field-hockey.png") },
      { name: "Curling", image: require("../../../assets/landingAssets/carouselAssets/curling.png") },
      { name: "Boxing", image: require("../../../assets/landingAssets/carouselAssets/boxing.png") }
    ],
    [
      { name: "Cricket", image: require("../../../assets/landingAssets/carouselAssets/cricket.png") },
      { name: "Snowboarding", image: require("../../../assets/landingAssets/carouselAssets/snowboarding.png") },
      { name: "Ping Pong", image: require("../../../assets/landingAssets/carouselAssets/ping-pong.png") },
      { name: "Lacrosse", image: require("../../../assets/landingAssets/carouselAssets/lacrosse.png") },
      { name: "Powerlifting", image: require("../../../assets/landingAssets/carouselAssets/Powerlifting.png") }
    ],
    [
      { name: "Gymnastics", image: require("../../../assets/landingAssets/carouselAssets/gymnastics.png") },
      { name: "Ice Hockey", image: require("../../../assets/landingAssets/carouselAssets/ice-hockey.png") },
      { name: "Archery", image: require("../../../assets/landingAssets/carouselAssets/archery.png") },
      { name: "Badminton", image: require("../../../assets/landingAssets/carouselAssets/badminton.png") },
      { name: "Rowing", image: require("../../../assets/landingAssets/carouselAssets/rowing.png") }
    ],
    [
      { name: "Climbing", image: require("../../../assets/landingAssets/carouselAssets/climbing.png") },
      { name: "Fencing", image: require("../../../assets/landingAssets/carouselAssets/fencing.png") },
      { name: "Horse Riding", image: require("../../../assets/landingAssets/carouselAssets/horse-riding.png") },
      { name: "Polo", image: require("../../../assets/landingAssets/carouselAssets/polo.png") },
      { name: "Skateboarding", image: require("../../../assets/landingAssets/carouselAssets/skateboarding.png") },
    ],
    [
      { name: "Surfing", image: require("../../../assets/landingAssets/carouselAssets/surfing.png") },
      { name: "Ultimate", image: require("../../../assets/landingAssets/carouselAssets/ultimate-frisbee.png") },
      { name: "Bodybuilding", image: require("../../../assets/landingAssets/carouselAssets/bodybuilding.png") },
      { name: "Dance", image: require("../../../assets/landingAssets/carouselAssets/dance.png") },
      { name: "Mental", image: require("../../../assets/landingAssets/carouselAssets/mental-coaching.png") }
    ]
  ]

  const smallViewSportOptions = [
    [
      { name: "Tennis", image: require("../../../assets/landingAssets/carouselAssets/tennis.png") },
      { name: "Golf", image: require("../../../assets/landingAssets/carouselAssets/golf.png") },
      { name: "Pickleball", image: require("../../../assets/landingAssets/carouselAssets/pickleball.png") }
    ],
    [
      { name: "Football", image: require("../../../assets/landingAssets/carouselAssets/football.png") },
      { name: "Soccer", image: require("../../../assets/landingAssets/carouselAssets/soccer.png") },
      { name: "Baseball", image: require("../../../assets/landingAssets/carouselAssets/baseball.png") }
    ],
    [
      { name: "Basketball", image: require("../../../assets/landingAssets/carouselAssets/basketball.png") },
      { name: "Running", image: require("../../../assets/landingAssets/carouselAssets/running.png") },
      { name: "Softball", image: require("../../../assets/landingAssets/carouselAssets/softball.png") }
    ],
    [
      { name: "Swimming", image: require("../../../assets/landingAssets/carouselAssets/swimming.png") },
      { name: "Cycling", image: require("../../../assets/landingAssets/carouselAssets/cycling.png") },
      { name: "Volleyball", image: require("../../../assets/landingAssets/carouselAssets/volleyball.png") }
    ],
    [
      { name: "Skiing", image: require("../../../assets/landingAssets/carouselAssets/skiing.png") },
      { name: "Martial Arts", image: require("../../../assets/landingAssets/carouselAssets/wrestling.png") },
      { name: "Water Polo", image: require("../../../assets/landingAssets/carouselAssets/water-polo.png") }
    ],
    [
      { name: "Rugby", image: require("../../../assets/landingAssets/carouselAssets/rugby.png") },
      { name: "Track & Field", image: require("../../../assets/landingAssets/carouselAssets/track-and-field.png") },
      { name: "Boxing", image: require("../../../assets/landingAssets/carouselAssets/boxing.png") },
    ],
    [
      { name: "Curling", image: require("../../../assets/landingAssets/carouselAssets/curling.png") },
      { name: "Field Hockey", image: require("../../../assets/landingAssets/carouselAssets/field-hockey.png") },
      { name: "Cricket", image: require("../../../assets/landingAssets/carouselAssets/cricket.png") }
    ],
    [
      { name: "Ping Pong", image: require("../../../assets/landingAssets/carouselAssets/ping-pong.png") },
      { name: "Snowboarding", image: require("../../../assets/landingAssets/carouselAssets/snowboarding.png") },
      { name: "Lacrosse", image: require("../../../assets/landingAssets/carouselAssets/lacrosse.png") }
    ],
    [
      { name: "Powerlifting", image: require("../../../assets/landingAssets/carouselAssets/Powerlifting.png") },
      { name: "Gymnastics", image: require("../../../assets/landingAssets/carouselAssets/gymnastics.png") },
      { name: "Ice Hockey", image: require("../../../assets/landingAssets/carouselAssets/ice-hockey.png") }
    ],
    [
      { name: "Archery", image: require("../../../assets/landingAssets/carouselAssets/archery.png") },
      { name: "Badminton", image: require("../../../assets/landingAssets/carouselAssets/badminton.png") },
      { name: "Rowing", image: require("../../../assets/landingAssets/carouselAssets/rowing.png") }
    ],
    [
      { name: "Climbing", image: require("../../../assets/landingAssets/carouselAssets/climbing.png") },
      { name: "Fencing", image: require("../../../assets/landingAssets/carouselAssets/fencing.png") },
      { name: "Horse Riding", image: require("../../../assets/landingAssets/carouselAssets/horse-riding.png") }
    ],
    [
      { name: "Polo", image: require("../../../assets/landingAssets/carouselAssets/polo.png") },
      { name: "Skateboarding", image: require("../../../assets/landingAssets/carouselAssets/skateboarding.png") },
      { name: "Surfing", image: require("../../../assets/landingAssets/carouselAssets/surfing.png") }
    ],
    [
      { name: "Ultimate", image: require("../../../assets/landingAssets/carouselAssets/ultimate-frisbee.png") },
      { name: "Bodybuilding", image: require("../../../assets/landingAssets/carouselAssets/bodybuilding.png") },
      { name: "Dance", image: require("../../../assets/landingAssets/carouselAssets/dance.png") }
    ],
    [
      { name: "Mental", image: require("../../../assets/landingAssets/carouselAssets/mental-coaching.png") }
    ]
  ]

  const sports = (displaySize === "large" ? largeViewSportOptions : smallViewSportOptions)

  const nextSlide = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % sports.length)
  };

  const prevSlide = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === 0 ? sports.length - 1 : prevIndex - 1
    );
  };

  const handleSelectSport = (sport:any) => {
    setSelectedSport(sport);
  };

  return (
    <div className="relative w-80 lg:w-7/12 mx-auto">
      {/* Carousel */}
      <div className="relative w-full rounded-2xl flex justify-center bg-white">
        {sports.map((group, index) => (
          <div
            key={index}
            className={`absolute w-full bg-white grid grid-cols-3 gap-1 lg:grid-cols-5 lg:gap-3 transition-opacity duration-700 px-10 lg:px-12 xl:px-14 py-1 border rounded-2xl ${
                index === activeIndex ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}
            `}
          >
            {group.map((sport, i) => (
              <div
                key={i}
                className="flex flex-col items-center cursor-pointer p-1 lg:p-1.5 lg:mx-0.5 my-auto w-full hover:bg-main-grey-100 rounded-xl transition-all"
                onClick={() => navigate(`/home-feed?sport=${sport.name}&location=Toronto%2C+ON&proximity=50&priceValue=10&priceMin=0&priceMax=70&page=1`)}
              >
                <img src={sport.image} alt={`${sport.name} icon provided by Freepik, available at https://www.flaticon.com/free-icons/`} className="w-4 h-4 lg:w-5 lg:h-5 xl:w-6 xl:h-6 object-contain" />
                <p className="mt-1 lg:mt-1.5 text-xs lg:text-sm text-center font-kulim">{sport.name}</p>
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* Navigation Buttons */}
      <button
        onClick={prevSlide}
        className="absolute top-3.5 lg:top-5 left-2 lg:left-2.5 z-30 flex items-center justify-center px-1 rounded-xl cursor-pointer text-black text-lg lg:text-2xl bg-gray-200 hover:bg-gray-400"
      >
        &#8592;
      </button>
      <button
        onClick={nextSlide}
        className="absolute top-3.5 lg:top-5 right-2 lg:right-2.5 z-30 flex items-center justify-center px-1 rounded-xl cursor-pointer text-black text-lg lg:text-2xl bg-gray-200 hover:bg-gray-400"
      >
        &#8594;
      </button>
    </div>
  )
}
